// extracted by mini-css-extract-plugin
module.exports = {"past-transactions-container":"PastTransactions_past-transactions-container__2uNLB","past-transactions-content":"PastTransactions_past-transactions-content__muGPU"};